var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"big-screen-loading"},[_c('div',{staticClass:"loading-inner"},[_c('img',{staticClass:"loading-img",attrs:{"src":require('@assets/bigscreen/loading.png')}})]),_c('div',{staticClass:"loading-text"},[_vm._v("加载中...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }